module.exports = __webpack_public_path__ + "img/check.5d6faad8.svg";